type ResourceValidationRules<TRule> = {
    name: TRule[];
    type: TRule[];
    status: TRule[];
    role?: TRule[];
};

export const buildResourceValidationRules = <TRule>(
    isCrewOrCast: boolean,
    isTemplate: boolean,
    staticRules: ResourceValidationRules<TRule>,
    roleRules: TRule[]
): ResourceValidationRules<TRule> => {
    const validationRules = {
        ...staticRules,
        ...(isCrewOrCast && !isTemplate && { role: roleRules })
    };

    return validationRules;
};
